module.exports = __webpack_public_path__ + "static/media/Cash.32ae4e0b.svg";